import React from 'react';
import { Modal, Table, Tag, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const PlanRemovalBlockedModal = ({ open, onClose, blockingPolicies = [], message }) => {
  const columns = [
    { title: 'Policy no.', dataIndex: 'policy_no', key: 'policy_no', render: (v) => v || '—' },
    { title: 'Name', dataIndex: 'name', key: 'name', render: (v) => v || '—' },
    { title: 'Phone', dataIndex: 'phone', key: 'phone', render: (v) => v || '—' },
    {
      title: 'Care history',
      dataIndex: 'has_care',
      key: 'has_care',
      render: (v) => (v ? <Tag color="volcano">Yes</Tag> : <Tag>No</Tag>),
    },
  ];

  return (
    <Modal
      open={open}
      title={
        <span>
          <ExclamationCircleOutlined style={{ color: '#fa541c', marginRight: 8 }} />
          Cannot remove plan
        </span>
      }
      onCancel={onClose}
      onOk={onClose}
      okText="Close"
      cancelButtonProps={{ style: { display: 'none' } }}
      width={720}
      destroyOnClose
    >
      <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        {message || 'Active members on this plan have care history. Deactivate or migrate them before removing the plan type.'}
      </Text>
      <Table
        size="small"
        rowKey={(row, idx) => row.client_id ?? row.policy_no ?? idx}
        columns={columns}
        dataSource={blockingPolicies}
        pagination={blockingPolicies.length > 10 ? { pageSize: 10 } : false}
        locale={{ emptyText: 'No blocking policy details returned.' }}
      />
    </Modal>
  );
};

export default PlanRemovalBlockedModal;
